import React from "react";
import { useNavigate } from "react-router-dom";
import { Disclosure } from "@headlessui/react";
import Logo from "../Logo/logo";
import { FiMessageSquare } from "react-icons/fi";
import { MdAccountCircle } from "react-icons/md";
import { FaArrowLeft } from "react-icons/fa6";
import { useParams } from "react-router-dom";

const Navbar = ({ counter, first, last, propertyMobile, propertyLogo }) => {
	const navigate = useNavigate();
	const guestid = useParams();
	const guestSessionId = guestid.id;

	const handleCancel = () => {
		navigate(`/${guestSessionId}`);
	};

	const handleHome = () => {
		navigate(`/${guestSessionId}`);
	};

	const handleOpenMessagingApp = () => {
		const phoneNumber = propertyMobile; // Include the country code here
		const message = "Hello, I need some help!";
		const smsLink = `sms:${phoneNumber}?body=${encodeURIComponent(message)}`;

		window.location.href = smsLink;
	};

	return (
		<Disclosure as="header" className="bg-gray-800 sticky top-0 z-50">
			<div className="mx-auto max-w-7xl px-2 sm:px-2 lg:divide-y lg:divide-gray-700 lg:px-4">
				<div className="relative flex h-16 justify-between">
					<div className="flex">
						{counter === undefined ? (
							<>
								<div className="relative z-10 flex lg:px-0">
									<div className="flex flex-shrink-0 items-center w-32">
										<img
											src={propertyLogo}
											alt="propertyLogo"
											className="object-contain w-full h-full"
										></img>
									</div>
								</div>
								<div className="relative z-0 flex flex-1 items-center justify-center px-2 sm:absolute sm:inset-0 w-48 ">
									<div className="text-center text-[#FFFFFF] font-poppins">
										<div className="text-[15px] font-normal leading-5">
											Welcome
										</div>
										{first?.toLowerCase() !== "qr" && (
											<div className="text-[15px] font-normal leading-5">
												{first}
											</div>
										)}
									</div>
								</div>
							</>
						) : (
							<div className="relative z-10 flex px-2 lg:px-0">
								<div className="flex flex-shrink-0 items-center justify-center">
									{counter % 4 === 1 ? (
										<button
											onClick={handleCancel}
											className="text-black px-2 py-1 text-sm bg-white rounded-xl"
										>
											Cancel
										</button>
									) : (
										<button
											onClick={handleHome}
											className="text-black px-2 py-1 text-sm bg-white rounded-xl"
										>
											<div className="flex items-center justify-center space-x-1">
												<FaArrowLeft />
												<div>Home</div>
											</div>
										</button>
									)}
								</div>
							</div>
						)}
					</div>
					<div className="relative flex px-3 justify-between">
						<button
							type="button"
							onClick={handleOpenMessagingApp}
							className="text-[#F9FAFB] text-[25px]"
						>
							<FiMessageSquare />
						</button>
						{/* <button type="button" className="text-[#F9FAFB] text-[25px] px-2">
              <MdAccountCircle />
            </button> */}
					</div>
				</div>
			</div>
		</Disclosure>
	);
};

export default Navbar;
